/**
 * [BLURY] | 🥭 SelectedShapePanel
 * Per-shape controls for whatever handle is currently selected.
 * @build 13.09.26
 * @updated 13.09.26 PHT
 * @author TONYTONY Sàrl
 */
import { useStudio } from '@/state/useStudio';
import { Button } from '../ui/Button';
import { Slider } from '../ui/Slider';
import { Swatch } from '../ui/Swatch';
import styles from './SelectedShapePanel.module.css';

export function SelectedShapePanel() {
  const selected = useStudio(s => s.selected);
  const shape = useStudio(s => s.composition.shapes[s.selected]);
  const updateShape = useStudio(s => s.updateShape);
  const removeShape = useStudio(s => s.removeShape);

  if (!shape) {
    return <p className={styles.empty}>no shape selected</p>;
  }

  return (
    <div className={styles.panel}>
      <h3 className={styles.title}>
        <i className={styles.badge}>{selected}</i>
        selected shape
      </h3>

      <Slider
        label="radius"
        value={Math.round(shape.r * 100)}
        min={3}
        max={160}
        format={v => `${v}%`}
        onChange={v => updateShape(selected, { r: v / 100 })}
      />
      <Slider
        label="opacity"
        value={Math.round(shape.a * 100)}
        min={0}
        max={100}
        format={v => `${v}%`}
        onChange={v => updateShape(selected, { a: v / 100 })}
      />

      <div className={styles.footer}>
        <Swatch
          className={styles.footerSwatch}
          label="colour"
          value={shape.c}
          onChange={c => updateShape(selected, { c })}
        />
        <Button variant="warn" className={styles.footerButton} onClick={() => removeShape(selected)}>
          delete
        </Button>
      </div>
    </div>
  );
}
